import {get,post} from "@/utils/http"
//基本设置 获取信息
export const _delete=params=>get("/cache/delete",params)
export const _set=params=>get("/cache/set",params)

